import { Component } from "@angular/core";
import { environment } from "src/environments/environment";
@Component({
  templateUrl: "./cancel.component.html",
  styleUrls: ["cancel.css"]
})
export class CancelComponent {
  environment: any
  constructor() {
    this.environment = environment
  }
}
